<div [class.searching]="this.query().length > 0">
  <div class="flex flex-col">
    <h3>Kundesøgning</h3>
    <div class="flex items-center">
      <mat-form-field appearance="outline" class="flex-grow" [subscriptSizing]="'dynamic'">
        <input matInput type="text" placeholder="Søg efter telefonnr., email, Visma-nr. eller navn" autofocus [ngModel]="query()" (keyup.enter)="algoliaHits.selectFirstCustomer(query())" (ngModelChange)="search($event)">
        @if (this.query().length > 0) {
          <mat-icon matSuffix (click)="resetSearch()">close</mat-icon>
        }
      </mat-form-field>
      <button mat-flat-button class="ms-4" (click)="createCustomer()" tabindex="-1">Opret kunde</button>
    </div>
  </div>
  <app-algolia-hits #algoliaHits/>
</div>
